// src/api/filterByCheckboxServices.js
import axios from 'axios';

import { API_BASE_URL } from './config';

export const filterByCheckboxServices = async (filterParams) => {
    try {
        console.log('Sending params to backend:', filterParams);

        const response = await axios.get(`${API_BASE_URL}/filter-by-checkbox-services/`, {
            params: filterParams
        });

        console.log('Response from backend:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error filtering by checkbox services:', error);
        throw error;
    }
};
